import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPalmTree = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.52578 4.85625L5.47265 6.43437C5.34765 6.54375 5.22265 6.65938 5.09765 6.78438C2.8789 9.00313 3.2164 11.5031 4.07578 12.7625C4.23203 12.9906 4.55078 12.9906 4.74453 12.7937L9.07265 8.46562C9.19765 8.80312 9.3164 9.28438 9.37578 9.94063C9.50703 11.3938 9.32578 13.5906 8.3539 16.7031C8.26015 17.0063 8.31328 17.3375 8.5039 17.5938C8.69453 17.85 8.9914 18 9.31015 18H11.3102C11.8133 18 12.2414 17.625 12.3039 17.125C12.6914 14.0312 12.232 10.65 11.3133 8H15.2695C15.357 8 15.4383 7.95312 15.4852 7.87813L16.0977 6.85625C16.1945 6.69375 16.4289 6.69375 16.5258 6.85625L17.1383 7.87813C17.182 7.95312 17.2664 8 17.3539 8H18.8102C19.0852 8 19.3133 7.775 19.2602 7.50313C18.9758 6.00625 17.4477 4 14.3102 4C12.9445 4 11.8852 4.38125 11.0977 4.93125C10.5758 3.54375 9.06015 2 6.31015 2C3.17265 2 1.64453 4.00625 1.36015 5.50312C1.30703 5.775 1.53515 6 1.81015 6H3.26953C3.35703 6 3.43828 5.95312 3.48515 5.87812L4.09453 4.85625C4.1914 4.69375 4.42578 4.69375 4.52265 4.85625H4.52578Z",
		fill: "#0D2976"
	})
});
export default SvgPalmTree;
